<template>
  <div class="content">
    <div class="img-box"></div>
    <div class="bd flex flex-v flex-pack-center">
      <div class="flex-1"></div>
      <div class="logo">
        <div class="flex logo-top">
          <van-image height="36px" radius="18px" :src="logo" width="36px" />
          <div class="name">{{ getCaseName }}</div>
        </div>
        <div class="profile">{{ getTenantProfile }}</div>
      </div>
      <van-form v-if="showInput" class="form" label-width="60px">
        <van-cell-group class="group">
          <van-field v-model="username" label="" name="用户名" placeholder="请输入姓名" />
          <van-field
            v-model="password"
            label=""
            name="密码"
            placeholder="请输入密码"
            type="password"
          />
        </van-cell-group>
        <div style="margin: 16px 0">
          <van-button
            block
            class="submit-btn"
            :loading="loading"
            native-type="submit"
            plain
            @click="onSubmit"
          >
            登录
          </van-button>
        </div>
      </van-form>
      <div v-if="isWeixin()">
        <van-button
          block
          class="mt10 wechat-icon"
          color="#000"
          :loading="vxloading"
          native-type="submit"
          round
          @click="toWechatLogin"
        >
          <template #icon>
            <van-icon name="wechat" />
          </template>
          微信登录
        </van-button>
      </div>
      <div v-else class="flex flex-align-center flex-pack-center">
        <wxlogin
          v-if="wx.appid"
          :appid="wx.appid"
          :redirect_uri="wx.redirectUri"
          response_type="code"
          scope="snsapi_login"
          :state="wx.state"
          :theme="'white'"
        />
      </div>
      <div class="agreement flex flex-pack-center flex-align-center">
        <div
          class="ty-radio flex flex-align-center"
          :class="{ current: agree }"
          @click="agree = !agree"
        >
          <div class="ty-radio__icon flex flex-align-center flex-pack-center">
            <!-- <uni-icons v-if="agree" customPrefix="iconfont" type="icon-select" color="#000" size="20"></uni-icons> -->
            <van-icon v-if="agree" name="success" />
          </div>
          <div class="">阅读并同意</div>
        </div>
        <span @click="goAgreement">《用户协议》</span>
        <span @click="privacyPolicy">《隐私政策》</span>
      </div>
      <div class="flex-1"></div>
      <div class="copyright">
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021137271号</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { addErrorLog } from "@/utils/errorLog";
import { ref, onMounted } from "vue";
import { Notify, Toast, toast } from "vant";
import { useRouter, useRoute } from "vue-router";
import { uuid, uploadFromUrl, isWeixin } from "@/utils";
// import { showToast } from 'vant'
import wxlogin from "vue-wxlogin";
import { getToken } from "@/utils/token";
import api from "@/api";
import store from "@/store";
import storage from "@/utils/storage";
import md5 from "js-md5";
const getUrlKey = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var rrr = decodeURIComponent(window.location.search);
  var r = rrr.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

let logo = ref(require("@/assets/images/logo.png"));
const username = ref("");
const agree = ref(false);
const password = ref("");
const router = useRouter();
const route = useRoute();
const redirect = decodeURIComponent(route.query.redirect || "/");
// 用于扫码登录跳转
if (redirect && redirect != "/") {
  storage.set("redirect", redirect);
}
const getCaseName = ref("");
const getTenantProfile = ref("");
const tenant = ref(null);
// 用于非微信端口时用于手动登录
const showInput = ref(route.query.showInput);

let loading = ref(false);
let vxloading = ref(false);
const wx = ref({});

onMounted(() => {
  const hostname = location.hostname;
  if (/192|test|dev|hanson/g.test(hostname)) {
    showInput.value = true;
  }
  init();
});

const init = async () => {
  const tenant = await store.getters["user/getTenant"];
  console.log(tenant);
  tenant.value = tenant;
  getCaseName.value = tenant.TenantName || tenant.PortalName || "";
  getTenantProfile.value = tenant.TenantProfile || "";
  if (tenant.LogoMedium) {
    logo.value = api.FileHost + tenant.LogoMedium;
  }
  const token = getToken();
  // 用于不同租户切换时确保绑定关系
  // const hasLoginTenant = JSON.parse(storage.get('hasLoginTenant')) || []
  // if (token && hasLoginTenant && hasLoginTenant.includes(tenant.TenantId)) {
  //   const origin = location.origin
  //   const pathname = location.pathname
  //   const url = origin + pathname + '#' + redirect
  //   location.href = url
  //   return
  // }
  // 如果有code 说明微信登录回调回来了
  const code = getUrlKey("code");
  if (code) {
    vxloading.value = true;
    wechatLogin(code);
  }

  getScanWxLogin();
};
// 微信扫码登录
const getScanWxLogin = async () => {
  await WechatGetOpenAppID().then((data) => {
    const { AppId, State } = data;
    if (AppId) {
      const targetUri = encodeURIComponent(
        `${location.origin}${location.pathname}#/passport`
      );
      const redirectUri = encodeURIComponent(
        `http://passport.tengyucloud.com/#/passport?targetUri=${targetUri}`
      );
      wx.value.appid = AppId;
      wx.value.redirectUri = redirectUri;
      wx.value.state = State;
    }
  });
};

const WechatGetOpenAppID = () => {
  return new Promise((resolve, reject) => {
    store
      .dispatch("user/WechatGetOpenAppID")
      .then((data) => {
        resolve(data.Data);
      })
      .catch((e) => {});
  });
};

const toWechatLogin = async () => {
  if (!agree.value) {
    // this.Toast( '请先阅读并同意用户服务协议' )
    // showToast('请先阅读并同意用户服务协议')
    toast("请先阅读并同意用户服务协议");
    return;
  }
  vxloading.value = true;
  const { Code, Data } = await store.dispatch("user/WechatGetAppID").catch((e) => {
    vxloading.value = false;
    Notify("获取appId失败，请稍后重试！");
  });
  if (Code !== 0) {
    vxloading.value = false;
    Notify("获取appId失败，请稍后重试！");
    return;
  }
  vxloading.value = false;
  const appId = Data.AppId;
  const state = Data.State;
  const origin = location.origin;
  const pathname = location.pathname;
  let url = `${origin}${pathname}#${route.path}?redirect=${encodeURIComponent(
    redirect
  )}&random=${Math.random()}`;
  url = encodeURIComponent(url);
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
};

const wechatLogin = async (code) => {
  const tenant = await store.getters["user/getTenant"];
  store
    .dispatch("user/WechatAuthor", {
      Code: code,
      tenantId: tenant.TenantId,
      Expires: 7,
    })
    .then(async (data) => {
      const { Code, Data } = data;
      vxloading.value = false;
      if (Code === 0) {
        try {
          if (Data.Avatar) {
            await saveImg(Data.Avatar);
          }
          //await saveLoginTenant(tenant.TenantId)
          const origin = location.origin;
          const pathname = location.pathname;
          const url = origin + pathname + "#" + redirect;
          location.href = url;
        } catch (error) {
          addErrorLog("微信登录成功但有异常" + data + error);
        }
      } else {
        addErrorLog("微信登录失败" + data);
        Notify("登录失败，请稍后重试！");
      }
    })
    .catch((e) => {
      vxloading.value = false;
      let msg = "微信登录失败";
      switch (e.Code) {
        case 2000:
          msg = `贵公司服务暂未启用，请联系腾宇一号!`;
          break;
        // case 2001:
        //   msg = `您还未加入${this.tenant.TenantName}，请联系管理员!`
        //   break
        case 7000:
          msg = `租户不存在，请联系腾宇一号!`;
          break;
        case 7002:
          msg = `贵公司服务已过期，请联系腾宇一号!`;
          break;
        default:
          break;
      }
      Toast(msg);
      addErrorLog("微信登录失败catch" + e);
    });
};

// const saveLoginTenant = (tenantId) => {
//   return new Promise((resolve, reject) => {
//     const hasLoginTenant = storage.get('hasLoginTenant')
//     const loginTenant = hasLoginTenant ? JSON.parse(hasLoginTenant) : []
//     if (!loginTenant.includes(tenantId)) {
//       loginTenant.push(tenantId)
//     }
//     storage.set('hasLoginTenant', JSON.stringify(loginTenant))
//     resolve(true)
//   })
// }

const saveImg = async (url) => {
  return new Promise((resolve, reject) => {
    uploadFromUrl(url)
      .then(async (data) => {
        if (data.data.Code === 0) {
          const tenant = await store.getters["user/getTenant"];
          store
            .dispatch("user/UserUpdateAvatar", {
              tenantId: tenant.TenantId,
              Avatar: data.data.Data,
            })
            .then(({ Code, Message }) => {
              resolve();
              if (Code === 0) {
                console.log("头像更新成功");
              } else {
                console.log("头像更新失败", Message);
              }
            })
            .catch((e) => {
              resolve();
              console.log(e);
            });
        } else {
          resolve();
          console.log("图片保存失败");
        }
      })
      .catch((e) => {
        resolve();
        console.log("图片保存失败", e);
      });
  });
};
const goAgreement = () => {
  router.push({ path: "/legalagreement" });
  // console.log('...')
};
const privacyPolicy = () => {
  router.push({ path: "/privacyPolicy" });
  // console.log('...')
};

// 登录handler
const onSubmit = async () => {
  const name = username.value;
  const pwd = password.value;
  if (!name) {
    toast("请输入用户名！");
    return;
  }
  if (!pwd) {
    toast("请输入密码！");
    return;
  }
  loading.value = true;
  const tenant = await store.getters["user/getTenant"];
  const params = {
    account: name,
    password: md5(pwd),
    tenantId: tenant.TenantId,
    Expires: 999,
  };
  await store
    .dispatch("user/login", params)
    .then(async ({ Code }) => {
      if (Code === 0) {
        //await saveLoginTenant(tenant.TenantId)
        setTimeout(async () => {
          loading.value = false;
          await router.replace(handleRoute());
        }, 2000);
      }
    })
    .catch((e) => {
      console.log(e);
      let msg = "登录失败";
      switch (e.Code) {
        case 2000:
          msg = `贵公司服务暂未启用，请联系腾宇一号!`;
          break;
        // case 2001:
        //   msg = `您还未加入${this.tenant.TenantName}，请联系管理员!`
        //   break
        case 7000:
          msg = `租户不存在，请联系腾宇一号!`;
          break;
        case 7002:
          msg = `贵公司服务已过期，请联系腾宇一号!`;
          break;
        default:
          break;
      }
      Toast(msg);
      loading.value = false;
    });
};

const handleRoute = () => {
  return redirect === "/404" || redirect === "/403" ? "/" : redirect;
};
</script>
<style lang="scss" scoped>
.content {
  height: 100vh;
  padding: 0 30px;
  color: #fff;
  position: relative;
  overflow: hidden;
  .img-box {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: url("https://file.tengyuone.com/88888/2022/11/07/e7d36f1eb93c4392a0ba36bc5833f53f.jpg")
      no-repeat #333;
    background-size: cover;
    z-index: -100;
    .image {
      width: auto;
      height: 100%;
      position: absolute;
      left: 0px;
    }
  }
  .bd {
    max-width: 800px;
    margin: 0 auto;
    min-height: 100vh;
    .logo {
      box-sizing: border-box;
      // display: flex;
      // align-items: center;
      .logo-top {
        align-items: center;
      }
      .profile {
        margin: 15px 0;
        line-height: 18px;
        height: 36px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .name {
        color: #fff;
        font-size: 20px;
        margin-left: 5px;
      }
    }
    .form {
      margin-top: 16px;
    }
    .submit-btn {
      background: transparent;
      border-radius: 50px;
      color: #fff;
    }
  }
}

// .mt10 {
//   margin-top: 10px;
// }
.copyright {
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 40px;
  text-align: center;
  margin: 20px;
  a {
    color: #bbb;
    font-size: 15px;
  }
}
.agreement {
  position: relative;
  margin: 16px 0;
}
.ty-radio__icon {
  width: 15px;
  height: 15px;
  border: 1px solid #fff;
  border-radius: 15px;
  margin-right: 5px;
}
.group {
  background: transparent;
  .van-cell {
    background: transparent;
  }
}
.wechat-icon {
  font-size: 17px;
}
</style>
